import React from 'react';
import '../../styles/DashboardComponents.css';

// Pill toggle générique à N options, généralisé du toggle Modélisé/Réel de
// ClientUsages.js (.cus-real-segmented). Utilisé pour la bascule Interactif/Export des
// cartes-graphiques, réutilisable pour tout futur contrôle à choix exclusif.
// `variant` choisit la teinte de l'état actif : 'accent' (orange, défaut — bascules de
// mode comme Interactif/Export) ou 'primary' (bleu — contrôles de données comme
// Réel/Estimé, Répartir par).
const SegmentedToggle = ({ options, value, onChange, ariaLabel, variant = 'accent' }) => (
    <div className={`segmented-toggle segmented-toggle--${variant}`} role="group" aria-label={ariaLabel}>
        {options.map((option) => (
            <button
                type="button"
                key={option.value}
                className={`segmented-toggle-option${option.value === value ? ' segmented-toggle-option--active' : ''}`}
                onClick={() => onChange(option.value)}
                title={option.title}
            >
                {option.label}
            </button>
        ))}
    </div>
);

export default SegmentedToggle;
